var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenTick = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 9,
  viewBox: "0 0 11 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.32479 8.39274C4.65599 9.09195 3.57561 9.09195 2.90681 8.38366L1.02902 6.39501C0.557427 5.89558 0.566001 5.08741 1.05474 4.60614C1.51776 4.13395 2.25516 4.15211 2.70103 4.6243L4.1158 6.1226L8.62914 1.28378C9.09215 0.793428 9.83813 0.793428 10.3011 1.28378L10.3354 1.3201C10.7985 1.81045 10.7985 2.60954 10.3269 3.0999L5.32479 8.39274Z",
  fill: "#79A342"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-tick.9325b6fb65b6f620820571690762385f.svg";